// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-area[data-v-7dbd24d5]{text-align:center}.mc-area img[data-v-7dbd24d5]{width:80px;margin:8px 0}.mc-text[data-v-7dbd24d5]{font-family:Noto Sans JP;font-size:15px;color:#fff}", ""]);
// Exports
module.exports = exports;
